import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const modal = (isSmallMode: boolean) =>
  !isSmallMode &&
  css`
    height: fit-content;
  `;

export const modalBody = css`
  overflow: auto;
  padding-top: ${theme.spacing(2)};
  padding-bottom: ${theme.spacing(2)};
`;

export const helperText = css`
  margin: ${theme.spacing(3, 0)};
`;

export const footer = (isSmallMode = false) =>
  isSmallMode &&
  css({
    boxShadow: theme.shadows.floating,
    padding: theme.spacing(2),
    gap: theme.spacing(1.25),
    display: 'flex',
    flexDirection: 'column-reverse',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
  });
